<template>
 <div id="app">
    <div class="content">
       <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  data () {
    return {
          // 帮助端
     list:[
        {parent:'陶笛音乐管理系统',child:[
        {title:'音乐管理',name:'Active'},
        {title:'用户管理',name:'Users'},
        {title:'项目介绍',name:'Intro'},
      ]},
      // {parent:'老师',child:[
      //   {title:'预约列表',name:'InfoList'},
      //   {title:'老师查询',name:'TeacherInfo'},
      // ]},
    ],
     }
  },
}
</script>

<style>
html{
  height: 100%;
}
body{
    padding: 0;
  margin: 0;
  height: 100%;
}
.left{
  width: 200px;
  height: 100%;
}
body{
  height: 100%;
}
#app {
  padding: 0;
  margin: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  display: flex;
  /* margin-top: 60px; */
}
.menu{
  position: absolute;
  top:0;
  left: 0;
  height: 100%;
  width: 200px;
  background-color: red;
}
.content{
  /* margin-left: 200px; */
  flex: 1;
  height: 100%;
  overflow: scroll;
}
a {
    text-decoration:none ;
    /* color: #00ecfc; */
}
.router-link-active {
    /* text-decoraction: none ; */
    /* color: #00ecfc; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue